"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiLogger = void 0;
var bi_const_1 = require("./bi.const");
var platform_bi_logger_adapter_1 = require("@wix/bookings-adapters-reporting/dist/src/bi-logger/platform-logger/platform-bi-logger-adapter");
var v2_1 = require("@wix/bi-logger-wixboost-ugc/v2");
var v2_2 = require("@wix/bi-logger-bookings-data/v2");
var BiLogger = /** @class */ (function () {
    function BiLogger(wixSdkAdapter) {
        this.wixSdkAdapter = wixSdkAdapter;
        this.biLoggerAdapter = new platform_bi_logger_adapter_1.PlatformBiLoggerAdapter({
            wixSdkAdapter: wixSdkAdapter,
            widgetName: bi_const_1.WIDGET_NAME_PHASE_0,
        });
    }
    BiLogger.prototype.sendCardClick = function (service_id, type, referralInfo) {
        var internalToLogType = { INDIVIDUAL: 'ind', GROUP: 'class' };
        return this.biLoggerAdapter.report((0, v2_1.bookingsBookItClick)({
            referralInfo: referralInfo,
            service_id: service_id,
            type: internalToLogType[type] || type,
        }));
    };
    BiLogger.prototype.sendViewerOpened = function (serviceId) {
        if (!this.wixSdkAdapter.isEditorMode()) {
            return this.biLoggerAdapter.report((0, v2_1.bookingsWidgetPageLoaded)({ serviceId: serviceId }));
        }
    };
    BiLogger.prototype.sendExposureTest = function () {
        return this.biLoggerAdapter.report((0, v2_1.bookingsTestsExposureEvent)({
            is_eligible: true,
            testName: 'Fully opened - specs.BookingsWidgetPhase0Spec',
            triggerName: bi_const_1.BI_EXPOSURE_TRIGGER_NAME,
            postreg_category: 'NA',
        }));
    };
    BiLogger.prototype.loadWidget = function () {
        return this.biLoggerAdapter.report((0, v2_2.bookingsUoUFlowWidgetLoadSrc16Evid32)({
            widget_name: 'single-service-widget',
        }));
    };
    return BiLogger;
}());
exports.BiLogger = BiLogger;
//# sourceMappingURL=bi-logger.js.map